"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _SelectionBox_canvas, _SelectionBox_coordinates, _SelectionBox_htmlElement, _SelectionBox_project;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectionBox = void 0;
const gl_matrix_1 = require("gl-matrix");
class SelectionBox {
    constructor(canvas) {
        _SelectionBox_canvas.set(this, void 0);
        _SelectionBox_coordinates.set(this, void 0);
        _SelectionBox_htmlElement.set(this, void 0);
        _SelectionBox_project.set(this, void 0);
        __classPrivateFieldSet(this, _SelectionBox_canvas, canvas, "f");
    }
    get coordinates() {
        return __classPrivateFieldGet(this, _SelectionBox_coordinates, "f");
    }
    intersectObjects(nodes, filterCriteria) {
        if (!__classPrivateFieldGet(this, _SelectionBox_coordinates, "f"))
            return [];
        const minX = Math.min(__classPrivateFieldGet(this, _SelectionBox_coordinates, "f").start.x, __classPrivateFieldGet(this, _SelectionBox_coordinates, "f").end.x);
        const maxX = Math.max(__classPrivateFieldGet(this, _SelectionBox_coordinates, "f").start.x, __classPrivateFieldGet(this, _SelectionBox_coordinates, "f").end.x);
        const minY = Math.min(__classPrivateFieldGet(this, _SelectionBox_coordinates, "f").start.y, __classPrivateFieldGet(this, _SelectionBox_coordinates, "f").end.y);
        const maxY = Math.max(__classPrivateFieldGet(this, _SelectionBox_coordinates, "f").start.y, __classPrivateFieldGet(this, _SelectionBox_coordinates, "f").end.y);
        // check if the selection is from the right or left side
        const isRightSelection = __classPrivateFieldGet(this, _SelectionBox_coordinates, "f").start.x < __classPrivateFieldGet(this, _SelectionBox_coordinates, "f").end.x;
        // for all nodes that can be intersected
        // check if the bounding sphere center is within the selection box
        const selectedObjects = [];
        nodes.forEach((i) => {
            const shouldTest = filterCriteria
                ? filterCriteria.some((fc) => fc(i))
                : true;
            if (!shouldTest)
                return;
            // for the selection from the right side, all points of the bounding box have to be included
            let isIncluded = false;
            let breakLoop = false;
            for (let xPoint of [i.boundingBox.min[0], i.boundingBox.max[0]]) {
                for (let yPoint of [
                    i.boundingBox.min[1],
                    i.boundingBox.max[1],
                ]) {
                    for (let zPoint of [
                        i.boundingBox.min[2],
                        i.boundingBox.max[2],
                    ]) {
                        const projection = __classPrivateFieldGet(this, _SelectionBox_project, "f").call(this, gl_matrix_1.vec3.fromValues(xPoint, yPoint, zPoint));
                        if (isRightSelection) {
                            if (!(projection[0] >= minX &&
                                projection[0] <= maxX &&
                                projection[1] >= minY &&
                                projection[1] <= maxY)) {
                                isIncluded = false;
                                breakLoop = true;
                            }
                            else {
                                isIncluded = true;
                            }
                        }
                        else {
                            if (projection[0] >= minX &&
                                projection[0] <= maxX &&
                                projection[1] >= minY &&
                                projection[1] <= maxY) {
                                isIncluded = true;
                                breakLoop = true;
                            }
                        }
                        if (breakLoop)
                            break;
                    }
                    if (breakLoop)
                        break;
                }
                if (breakLoop)
                    break;
            }
            if (isIncluded) {
                selectedObjects.push({
                    node: i,
                    type: "BoxSelectionIntersection",
                });
            }
        });
        return selectedObjects;
    }
    /**
     * Intersect drawing tool points with the selection box
     * @param points Array of 3D points to test
     * @returns Array of indices of points that are inside the selection box
     */
    intersectPoints(points) {
        if (!__classPrivateFieldGet(this, _SelectionBox_coordinates, "f") || !__classPrivateFieldGet(this, _SelectionBox_project, "f"))
            return [];
        const minX = Math.min(__classPrivateFieldGet(this, _SelectionBox_coordinates, "f").start.x, __classPrivateFieldGet(this, _SelectionBox_coordinates, "f").end.x);
        const maxX = Math.max(__classPrivateFieldGet(this, _SelectionBox_coordinates, "f").start.x, __classPrivateFieldGet(this, _SelectionBox_coordinates, "f").end.x);
        const minY = Math.min(__classPrivateFieldGet(this, _SelectionBox_coordinates, "f").start.y, __classPrivateFieldGet(this, _SelectionBox_coordinates, "f").end.y);
        const maxY = Math.max(__classPrivateFieldGet(this, _SelectionBox_coordinates, "f").start.y, __classPrivateFieldGet(this, _SelectionBox_coordinates, "f").end.y);
        const selectedPointIndices = [];
        points.forEach((point, index) => {
            const projection = __classPrivateFieldGet(this, _SelectionBox_project, "f").call(this, point);
            if (projection[0] >= minX &&
                projection[0] <= maxX &&
                projection[1] >= minY &&
                projection[1] <= maxY) {
                selectedPointIndices.push(index);
            }
        });
        return selectedPointIndices;
    }
    onDown(event, project) {
        __classPrivateFieldSet(this, _SelectionBox_project, project, "f");
        const rect = __classPrivateFieldGet(this, _SelectionBox_canvas, "f").getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
        const y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
        __classPrivateFieldSet(this, _SelectionBox_coordinates, {
            start: {
                x: x,
                y: y,
            },
            end: {
                x: x,
                y: y,
            },
        }, "f");
    }
    onEnd(event) {
        const rect = __classPrivateFieldGet(this, _SelectionBox_canvas, "f").getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
        const y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
        __classPrivateFieldGet(this, _SelectionBox_coordinates, "f").end = {
            x: x,
            y: y,
        };
    }
    onMove(event, insertionActive, removalActive) {
        // update box selection
        const rect = __classPrivateFieldGet(this, _SelectionBox_canvas, "f").getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
        const y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
        __classPrivateFieldGet(this, _SelectionBox_coordinates, "f").end = {
            x: x,
            y: y,
        };
        this.updateSelectionBox(insertionActive, removalActive);
    }
    reset() {
        var _a;
        (_a = __classPrivateFieldGet(this, _SelectionBox_htmlElement, "f")) === null || _a === void 0 ? void 0 : _a.remove();
        __classPrivateFieldSet(this, _SelectionBox_htmlElement, undefined, "f");
        __classPrivateFieldSet(this, _SelectionBox_coordinates, undefined, "f");
    }
    updateSelectionBox(insertionActive, removalActive) {
        if (!__classPrivateFieldGet(this, _SelectionBox_coordinates, "f"))
            return;
        let color = "0, 0, 255"; // blue
        if (insertionActive && !removalActive) {
            color = "0, 255, 0"; // green
        }
        else if (!insertionActive && removalActive) {
            color = "255, 0, 0"; // red
        }
        if (!__classPrivateFieldGet(this, _SelectionBox_htmlElement, "f")) {
            // create selection box div
            __classPrivateFieldSet(this, _SelectionBox_htmlElement, document.createElement("div"), "f");
            __classPrivateFieldGet(this, _SelectionBox_htmlElement, "f").style.position = "absolute";
            __classPrivateFieldGet(this, _SelectionBox_htmlElement, "f").style.border = `1px solid rgba(${color}, 0.8)`;
            __classPrivateFieldGet(this, _SelectionBox_htmlElement, "f").style.backgroundColor = `rgba(${color}, 0.1)`;
            __classPrivateFieldGet(this, _SelectionBox_htmlElement, "f").style.pointerEvents = "none";
            __classPrivateFieldGet(this, _SelectionBox_htmlElement, "f").style.zIndex = "9999"; // Ensure it's on top
            document.body.appendChild(__classPrivateFieldGet(this, _SelectionBox_htmlElement, "f"));
        }
        else {
            // check if the color needs to be updated
            const currentBorderColor = __classPrivateFieldGet(this, _SelectionBox_htmlElement, "f").style.border;
            const desiredBorderColor = `1px solid rgba(${color}, 0.8)`;
            if (currentBorderColor !== desiredBorderColor) {
                __classPrivateFieldGet(this, _SelectionBox_htmlElement, "f").style.border = desiredBorderColor;
                __classPrivateFieldGet(this, _SelectionBox_htmlElement, "f").style.backgroundColor = `rgba(${color}, 0.1)`;
            }
        }
        const rect = __classPrivateFieldGet(this, _SelectionBox_canvas, "f").getBoundingClientRect();
        // Convert normalized coordinates back to document coordinates
        const convertedStartX = ((__classPrivateFieldGet(this, _SelectionBox_coordinates, "f").start.x + 1) / 2) * rect.width + rect.left;
        const convertedStartY = ((1 - __classPrivateFieldGet(this, _SelectionBox_coordinates, "f").start.y) / 2) * rect.height + rect.top;
        const convertedEndX = ((__classPrivateFieldGet(this, _SelectionBox_coordinates, "f").end.x + 1) / 2) * rect.width + rect.left;
        const convertedEndY = ((1 - __classPrivateFieldGet(this, _SelectionBox_coordinates, "f").end.y) / 2) * rect.height + rect.top;
        const x = Math.min(convertedStartX, convertedEndX);
        const y = Math.min(convertedStartY, convertedEndY);
        const width = Math.abs(convertedEndX - convertedStartX);
        const height = Math.abs(convertedEndY - convertedStartY);
        __classPrivateFieldGet(this, _SelectionBox_htmlElement, "f").style.left = `${x}px`;
        __classPrivateFieldGet(this, _SelectionBox_htmlElement, "f").style.top = `${y}px`;
        __classPrivateFieldGet(this, _SelectionBox_htmlElement, "f").style.width = `${width}px`;
        __classPrivateFieldGet(this, _SelectionBox_htmlElement, "f").style.height = `${height}px`;
    }
}
exports.SelectionBox = SelectionBox;
_SelectionBox_canvas = new WeakMap(), _SelectionBox_coordinates = new WeakMap(), _SelectionBox_htmlElement = new WeakMap(), _SelectionBox_project = new WeakMap();
//# sourceMappingURL=SelectionBox.js.map